var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.992 0c4.975 0 9.01 4.03 9.01 9s-4.035 9-9.01 9a8.98 8.98 0 0 1-5.925-2.22l1.316-1.507A6.99 6.99 0 0 0 8.992 16a7.004 7.004 0 0 0 7.007-7c0-3.866-3.137-7-7.007-7a7 7 0 0 0-5.427 2.57l2.437 2.434L0 7.007l.002-5.998 2.143 2.14A9 9 0 0 1 8.992 0m.016 4a1 1 0 0 1 1 1v3.693l2.228 2.148c.39.377.402.999.025 1.39l-.012.012a1.02 1.02 0 0 1-1.428.013L8.48 10h-.474V5a1 1 0 0 1 1-1z"
  })));
});
const SvgTbVersionControlIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTbVersionControlIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik04Ljk5MiAwYzQuOTc1IDAgOS4wMSA0LjAzIDkuMDEgOXMtNC4wMzUgOS05LjAxIDlhOC45OCA4Ljk4IDAgMCAxLTUuOTI1LTIuMjJsMS4zMTYtMS41MDdBNi45ODUgNi45ODUgMCAwIDAgOC45OTIgMTZhNy4wMDQgNy4wMDQgMCAwIDAgNy4wMDctN2MwLTMuODY2LTMuMTM3LTctNy4wMDctN2E2Ljk5NyA2Ljk5NyAwIDAgMC01LjQyNyAyLjU3bDIuNDM3IDIuNDM0TDAgNy4wMDdsLjAwMi01Ljk5OCAyLjE0MyAyLjE0QTguOTkzIDguOTkzIDAgMCAxIDguOTkyIDB6bS4wMTYgNGExIDEgMCAwIDEgMSAxdjMuNjkzbDIuMjI4IDIuMTQ4Yy4zOS4zNzcuNDAyLjk5OS4wMjUgMS4zOWwtLjAxMi4wMTJhMS4wMiAxLjAyIDAgMCAxLTEuNDI4LjAxM0w4LjQ4IDEwaC0uNDc0VjVhMSAxIDAgMCAxIDEtMXoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";